import { keepPreviousData } from "@tanstack/react-query";
import { RouterOutputs, trpc } from "../trpc";

export type Implementation =
  RouterOutputs["implementation"]["implementations"][number];

interface Input {
  selectedApis?: string[];
}

interface Options {
  enabled?: boolean;
}

export function useQueryImplementations(
  { selectedApis }: Input,
  { enabled = true }: Options = {},
) {
  const { data, isFetching, isLoading } =
    trpc.implementation.implementations.useQuery(
      {
        selectedApis: selectedApis || [],
      },
      {
        enabled: !!selectedApis?.length && enabled,
        placeholderData: keepPreviousData,
      },
    );

  return {
    implementations: (data || []) as Implementation[],
    isLoading,
    isFetching,
  };
}
